import { render, staticRenderFns } from "./about.vue?vue&type=template&id=399c6977&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('399c6977')) {
      api.createRecord('399c6977', component.options)
    } else {
      api.reload('399c6977', component.options)
    }
    module.hot.accept("./about.vue?vue&type=template&id=399c6977&", function () {
      api.rerender('399c6977', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/about.vue"
export default component.exports